import DefaultSlider from '../../../organisms/org--default-slider';

class TextSlider extends DefaultSlider {
  constructor(options = {}) {
    super(options);
  }

  init() {
    super.init();
  }
}

export default TextSlider;
